import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { PunchOutData } from '../../model';
import { ConverterService } from '../../util';
import { PUNCH_OUT_DATA_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class PunchOutConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  load(userId: string): Observable<PunchOutData> {
    const url = this.occEndpointsService.buildUrl('punchOutData', { urlParams: { userId } });
    return this.httpClient.get(url).pipe(this.converterService.pipeable(PUNCH_OUT_DATA_NORMALIZER));
  }

  punchOut(cartId: string, userId: string): Observable<any> {
    const url = this.occEndpointsService.buildUrl('punchOut', { urlParams: { userId, cartCodeOrType: cartId } });
    return this.httpClient.post(url, {});
  }

  cancel(cartId: string, userId: string): Observable<any> {
    const url = this.occEndpointsService.buildUrl('punchOut', { urlParams: { userId, cartCodeOrType: cartId } });
    return this.httpClient.delete(url);
  }
}
